import React from "react"

class ColorDataType extends React.Component{

  render() {
    return (
      <div><span className="color-swatch" style={{backgroundColor: this.props.row.color}}></span></div>
    );
  }

};

export default ColorDataType